import $ from "jquery";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ContratAutoFromDsnDto } from "../../../dto/GenApi.iNotPaie.Dto/ContratAutoFromDsnDto";
import { ImportDsnAutoDto } from "../../../dto/GenApi.iNotPaie.Dto/ImportDsnAutoDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

@Component
export default class ModalDsn extends Vue {
    public dataReady = false;
    public ImportDsn?: ImportDsnAutoDto;

    public demande: ContratAutoFromDsnDto = {
        CodeSociete: "",
        File: ""
    }

    public init(): void {
        if (ParametresInstance.utilisateurCourant == undefined) {
            return;
        }

        this.demande = {
            CodeSociete: "",
            File: ""
        };

        if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
            this.demande.CodeSociete = ParametresInstance.societeCourante.Code;
        }

        $("#modalDsn").modal("show");
    }

    public deactivated(): void {
        this.resetFileInput();
    }

    public PutDsn(): void {
        if (this.demande.File == undefined || this.demande.File == "") {
            NotificationServiceInstance.SendFailed("Aucun fichier à lire.");

            return;
        }

        ServicesFactoryInstance.ContratAutoFromDsnService.PutFichierDsn(this.demande, data => {
            this.$emit("contratsCrees", data);
        }, () => {
            this.annuler();
        });
        $("#modalDsn").modal("hide");
    }

    public annuler(): void {
        this.demande.File = "";
        this.demande.CodeSociete = "";
        this.ImportDsn = undefined;
        this.resetFileInput();
        this.$emit("modalDsnAnnule");
        $("#modalDsn").modal("hide");
    }

    public resetFileInput(): void {
        const fileInput = this.$refs.fileInput as HTMLInputElement;
        if (fileInput != null) {
            fileInput.value = "";
        }
    }

    public changeFile(event: Event): void {
        this.init();
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) {
            return;
        }
        const someData = input.files[0]; // Je récupère le contenu de mon <input>
        const reader = new FileReader(); // Je crée mon objet reader
        const _this = this; // Permets d'accéder au this général même dans une fonction ?

        reader.onloadend = function () { // Quand le reader à finis de lire
            const src = reader.result; // On récupère son contenu
            _this.updateSrc(src);
        };

        if (someData) {
            reader.readAsText(someData, "UTF-8");
        }
    }

    public updateSrc(data: any): void {
        this.demande.File = data.toString();
    }
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalDsn/modalDsn.ts